import PageEdit from '@theme/components/PageEdit.vue';
import PageNav from '@theme/components/PageNav.vue';
import ArticleInfo from './ArticleInfo.vue';
import Catalogue from './Catalogue.vue';
import UpdateArticle from './UpdateArticle.vue';
import RightMenu from './RightMenu.vue';
import TitleBadgeMixin from '../mixins/titleBadge';
export default {
  mixins: [TitleBadgeMixin],
  data() {
    return {
      updateBarConfig: null
    };
  },
  props: ['sidebarItems'],
  components: {
    PageEdit,
    PageNav,
    ArticleInfo,
    Catalogue,
    UpdateArticle,
    RightMenu
  },
  created() {
    this.updateBarConfig = this.$themeConfig.updateBar;
  },
  computed: {
    bgStyle() {
      const {
        contentBgStyle
      } = this.$themeConfig;
      return contentBgStyle ? 'bg-style-' + contentBgStyle : '';
    },
    isShowUpdateBar() {
      return this.updateBarConfig && this.updateBarConfig.showToArticle === false ? false : true;
    },
    showTitle() {
      return !this.$frontmatter.pageComponent;
    },
    showRightMenu() {
      const {
        $frontmatter,
        $themeConfig,
        $page
      } = this;
      const {
        sidebar
      } = $frontmatter;
      return $themeConfig.rightMenuBar !== false && $page.headers && ($frontmatter && sidebar && sidebar !== false) !== false;
    },
    pageComponent() {
      return this.$frontmatter.pageComponent ? this.$frontmatter.pageComponent.name : false;
    },
    isShowSlotT() {
      return this.getShowStatus('pageTshowMode');
    },
    isShowSlotB() {
      return this.getShowStatus('pageBshowMode');
    }
  },
  methods: {
    getShowStatus(prop) {
      const {
        htmlModules
      } = this.$themeConfig;
      if (!htmlModules) return false;
      if (htmlModules[prop] === 'article') {
        // 仅文章页显示
        return this.isArticle();
      } else if (htmlModules[prop] === 'custom') {
        // 仅自定义页显示
        return !this.isArticle();
      } else {
        // 全部显示
        return true;
      }
    },
    isArticle() {
      return this.$frontmatter.article !== false;
    }
  }
};